import { render } from "./rental_body_main.vue?vue&type=template&id=00bf23a4"
import script from "./rental_body_main.vue?vue&type=script&lang=js"
export * from "./rental_body_main.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__